import React from 'react';
import { IncomingCall } from 'services/caller-id';
import { formatPhone } from 'utils/formatPhone';
import { PhoneIcon } from './icons';

interface CallBannerProps {
  call: IncomingCall;
  // stacking position among concurrently ringing banners
  index: number;
  onSms: (call: IncomingCall) => void;
  onBook: (call: IncomingCall) => void;
}

// State 1 — one banner per ring, stacked +64px apart, morphing out of the FAB
// spot (bannerGrow) then pulsing (ringPulse). Auto-dismiss is owned by the hook.
const CallBanner = ({ call, index, onSms, onBook }: CallBannerProps) => {
  const known = !!call.customer;
  const delay = `${(index * 0.16).toFixed(2)}s`;
  const pulseDelay = `${(index * 0.16 + 0.42).toFixed(2)}s`;
  return (
    <div
      className={`cid-banner ${known ? 'known' : 'unknown'}`}
      style={{
        top: 58 + index * 64,
        animationDelay: `${delay}, ${pulseDelay}`,
      }}
    >
      <span className="cid-banner-icon"><PhoneIcon size={19} /></span>
      <span className="cid-banner-body" style={{ animationDelay: delay }}>
        <span className="cid-banner-name-row">
          <span className="cid-banner-name">{call.customer ? call.customer.name : 'Unknown caller'}</span>
          {!known && <span className="cid-badge-new">new</span>}
        </span>
        <span className="cid-banner-phone">{formatPhone(call.phone)}</span>
      </span>
      <button type="button" className="cid-btn-sms" style={{ animationDelay: delay }} onClick={() => onSms(call)}>SMS</button>
      <button type="button" className="cid-btn-book" style={{ animationDelay: delay }} onClick={() => onBook(call)}>Book</button>
    </div>
  );
};

export default CallBanner;
